import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconFractureMultipleSizeS from './IconFractureMultiple_size_s';

const props: CreateIconArguments = {
  l: IconFractureMultipleSizeS,
  m: IconFractureMultipleSizeS,
  s: IconFractureMultipleSizeS,
  xs: IconFractureMultipleSizeS,
  name: 'IconFractureMultiple',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
